export default {
	colors: {
		color1: '#0072ac',
		color2: '#50b778',
		textColor: '#0072ac'
	},
	howTo: [
		{
			id: 1,
			content: '<div class="slide-image"><img src="assets/images/communication/how-to-1.jpg" alt="How To Slide 1" /></div><p>In the bottom left of the Outlook folder pane, click the three dots. Then click Folders.</p>'
		},
		{
			id: 2,
			content: '<div class="slide-image"><img src="assets/images/communication/how-to-2.jpg" alt="How To Slide 2" /></div><p>In the Folders pane that\'s now showing, scroll all the way down to Public Folders, and expand to Public Folders > All Public Folders > Calendars > PSD Calendar</p>'
		},
		{
			id: 3,
			content: '<div class="slide-image"><img src="assets/images/communication/how-to-3.jpg" alt="How To Slide 3" /></div><p>Right-click PSD Calendar and choose Add to Favorites. Click Add.</p>'
		},
		{
			id: 4,
			content: '<div class="slide-image"><img src="assets/images/communication/how-to-4.jpg" alt="How To Slide 4" /></div><p>On the left, expand to Public Folders > Favorites. Click the PSD Calendar to complete the initial sync.</p>'
		},
		{
			id: 5,
			content: '<div class="slide-image"><img src="assets/images/communication/how-to-5.jpg" alt="How To Slide 5" /></div><p>It will now show up in the Other Calendars section of Calendar view…Huzzah!</p>'
		}
	],
	docs: [
		{
			id: 1,
			title: "Phone Cheat Sheet",
			link: "assets/docs/Phone-cheat-sheet.pdf"
		}
		
	]
};



// WEBPACK FOOTER //
// ./src/data/Communication.js